module.exports = __webpack_public_path__ + "img/submit.0e022daa.svg";